import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import styles from './Wrapper.scss';

export default function Wrapper(props) {
    const wrapperStyleName = props.isDashboards
        ? 'wrapper-is-dashboards'
        : 'wrapper-is-not-dashboards';

    const navStyle = props.withSubmenu ? 'nav-with-submenu' : 'nav';

    return (
        <div className={styles[wrapperStyleName]} data-section="sidebar">
            <ul className={styles[navStyle]}>
                {props.children}
            </ul>
        </div>
    );
}

Wrapper.displayName = displayName('LeftHandNav/Wrapper');

Wrapper.propTypes = {
    isDashboards: PropTypes.bool,
    withSubmenu: PropTypes.bool,
    children: PropTypes.any,
};

Wrapper.defaultProps = {
    children: null,
    isDashboards: false,
    withSubmenu: false,
};
